// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"4814":"70cfe1b1","6925":"2c386607"}[chunkId] || chunkId) + "." + {"4814":"25cd1c55929c63af","6925":"f249ab703c598161","7229":"ae72fabb1f43e027","9894":"df6dba095f8d61ef"}[chunkId] + ".js";
};